// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"10":"3d63d512","423":"bfaf710d","499":"a751a7ae"}[chunkId] + ".js";
};